export function removeSessionStorageItem(key: string) {
  if (typeof window === 'undefined') return undefined;

  sessionStorage.removeItem(key);
}
